import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import {
	setInEditorTemplatesPanelQueryParam,
	IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN,
	CONTEXT_PANEL_TAB_TARGET_BLOCK,
} from '@confluence/template-utils/entry-points/urlUtils.ts';

export const useOpenSnippetPanel = (): (() => void) => {
	const { setQueryParams } = useRouteActions();

	return (): void => {
		setInEditorTemplatesPanelQueryParam(
			setQueryParams,
			IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN,
			CONTEXT_PANEL_TAB_TARGET_BLOCK,
		);
	};
};
